export enum SearchActionsEnum {
    ClearAll = '[search] clearAll',
    FetchResultsSuccess = '[search] fetchBookResultsSuccess',
    SetSearchResults = '[search] setSearchResults',
    GetSearchResults = '[search] getSearchResults',
}
